import React, { useState } from 'react';
import { t } from '@lingui/macro';
import styles from './Header.module.scss';
import GlobalSearchIcon from '@components/GlobalSearch/GlobalSearchIcon';
import { LanguageDropDown } from '@components/LanguageDropDown/LanguageDropDown';
import ProfileDropdown from '@components/ProfileDropdown/ProfileDropdown';
import PermissionService from 'services/permission.service';
import { AlertInbox } from '@components/AlertInbox/AlertInbox';
import { Notifications } from '@components/Notifications';
import { useAccountContext } from '@context/AccountContext';
import { useHistory, useLocation } from 'react-router';
import { GlobalSearch } from '@components/GlobalSearch/GlobalSearch';
import menuService from '@components/GlobalSearch/Services/MenuService/menu.service';
import { menuItems } from '@components/GlobalSearch/Routes';
import featureService from 'services/feature.service';
import { useIntl } from 'react-intl';
import { useAccess } from 'modules/Common/components/Access';
import { getClassName } from '@onsolve-ucl/utils.get-class-name';
import jwtService from '@services/jwt.service';
const Header = ({ leftItems = [], title = '', rightItems = [], useDefaultItems = true }) => {
    const { canViewAlertInbox, canViewAnnouncements } = new PermissionService().permissions;
    const { organizationName } = useAccountContext();
    const [isSearchOpen, setSearchOpen] = useState(false);
    const intl = useIntl();
    const access = useAccess();
    const location = useLocation();
    const history = useHistory();
    const userUuid = jwtService.getUserUuid();
    const [rootClass, getChildClass] = getClassName({
        rootClass: 'header',
        styles,
    });
    const isResponsePage = location?.pathname === '/response';
    const isRiskIntelligence = location?.pathname?.toLowerCase()?.startsWith('/riskintelligence');
    const getHeaderItemsRight = () => {
        if (location?.pathname === '/response')
            return [];
        if (!useDefaultItems)
            return rightItems;
        return [
            <GlobalSearchIcon handleClick={() => setSearchOpen(!isSearchOpen)} key="globalSearch"></GlobalSearchIcon>,
            !isRiskIntelligence && <LanguageDropDown key="langMenu"/>,
            canViewAlertInbox() && <AlertInbox key="alertInbox"/>,
            !isRiskIntelligence && canViewAnnouncements() && <Notifications key="announcementsTray"/>,
            !isRiskIntelligence && <ProfileDropdown key="profileDropdown"/>,
            ...rightItems,
        ];
    };
    const getHeaderItemsLeft = () => {
        if (isResponsePage)
            return [];
        if (!useDefaultItems)
            return leftItems;
        return [];
    };
    const getHeaderTitle = () => {
        if (isResponsePage)
            return t `Response Portal`;
        if (isRiskIntelligence)
            return '';
        return title || organizationName;
    };
    return (<header className={rootClass} data-testid="Header">
            {!isResponsePage && (<GlobalSearch isOpen={isSearchOpen} sideBarMenuItems={menuService(menuItems)} onClose={() => setSearchOpen(!isSearchOpen)} userId={userUuid} getFeature={featureService.getFeature} intl={intl} access={access} key={2} history={history}></GlobalSearch>)}
            <div className={getChildClass('actions_left')}>
                {getHeaderItemsLeft()}
                <div className={getChildClass('actions_left__portal_items_left')} id="header_portal_left"/>
                <h2 title={t `Account Name`} className={getChildClass('actions_left__account_name')}>
                    {getHeaderTitle()}
                </h2>
            </div>
            <div className={getChildClass('actions_right')}>
                {getHeaderItemsRight()}
                <div className={getChildClass('actions_right__portal_items_right')} id="header_portal_right"/>
            </div>
        </header>);
};
export default Header;
